import React from 'react'
import ThemeManager from "./ThemeManager"




export default function Navbar() {
  return (
    <div className="navbar bg-base-100 pt-0 fixed top-0 right-0 left-0 z-50">
        <div className="navbar-start">
        
          <a href='/' className="hidden btn btn-ghost text-xl md:flex ml-16">
            <img src="/logo.png" className="h-20 -mb-8" alt="Moncatalog" />
          </a>
        </div>
        <div className="md:ml-36 navbar-center  lg:flex">
       
          {/**<ul className="menu menu-horizontal px-1">
            a decommenter pour avoir articles et espaces
            *  <li className='mx-4'>
              <a><MdWorkspacesOutline size={40} className="text-gray-500 block" />Articles  </a>
              
            </li>
          
            <li>
              <a><MdOutlineViewInAr size={35} className="text-gray-500 block" /> Espaces  </a>
             
            </li>
          
            
          </ul>  */}
        </div>
        <div className="navbar-end mx-20 md:mx-16 hidden md:inline">
          <ThemeManager />
        </div>
      </div>
  )
}
